import { SVGAttributes } from 'react'

export const LocationIcon = (props: SVGAttributes<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    {...props}>
    <path strokeLinecap='round' strokeLinejoin='round' d='M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z' />
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z'
    />
  </svg>
)

export const GroupIcon = (props: SVGAttributes<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    className='size-6'
    {...props}>
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      // eslint-disable-next-line max-len
      d='M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z'
    />
  </svg>
)

export const LeftIcon = (props: SVGAttributes<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    {...props}>
    <path strokeLinecap='round' strokeLinejoin='round' d='M15.75 19.5 8.25 12l7.5-7.5' />
  </svg>
)

export const RightIcon = (props: SVGAttributes<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    {...props}>
    <path strokeLinecap='round' strokeLinejoin='round' d='m8.25 4.5 7.5 7.5-7.5 7.5' />
  </svg>
)

export const HeartIcon = (props: SVGAttributes<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    {...props}>
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      // eslint-disable-next-line max-len
      d='M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z'
    />
  </svg>
)

export const CrossIcon = (props: SVGAttributes<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    {...props}>
    <path strokeLinecap='round' strokeLinejoin='round' d='M6 18 18 6M6 6l12 12' />
  </svg>
)

export const SparklesIcon = (props: SVGAttributes<SVGSVGElement>) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
    className='shrink-0'
    {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      // eslint-disable-next-line max-len
      d='M3.99961 1.60001C4.21178 1.60001 4.41527 1.68429 4.56529 1.83432C4.71532 1.98435 4.79961 2.18783 4.79961 2.40001V3.20001H5.59961C5.81178 3.20001 6.01527 3.28429 6.16529 3.43432C6.31532 3.58435 6.39961 3.78783 6.39961 4.00001C6.39961 4.21218 6.31532 4.41566 6.16529 4.56569C6.01527 4.71572 5.81178 4.80001 5.59961 4.80001H4.79961V5.60001C4.79961 5.81218 4.71532 6.01566 4.56529 6.16569C4.41527 6.31572 4.21178 6.40001 3.99961 6.40001C3.78744 6.40001 3.58395 6.31572 3.43392 6.16569C3.2839 6.01566 3.19961 5.81218 3.19961 5.60001V4.80001H2.39961C2.18744 4.80001 1.98395 4.71572 1.83392 4.56569C1.68389 4.41566 1.59961 4.21218 1.59961 4.00001C1.59961 3.78783 1.68389 3.58435 1.83392 3.43432C1.98395 3.28429 2.18744 3.20001 2.39961 3.20001H3.19961V2.40001C3.19961 2.18783 3.2839 1.98435 3.43392 1.83432C3.58395 1.68429 3.78744 1.60001 3.99961 1.60001ZM3.99961 9.60001C4.21178 9.60001 4.41527 9.68429 4.56529 9.83432C4.71532 9.98435 4.79961 10.1878 4.79961 10.4V11.2H5.59961C5.81178 11.2 6.01527 11.2843 6.16529 11.4343C6.31532 11.5843 6.39961 11.7878 6.39961 12C6.39961 12.2122 6.31532 12.4157 6.16529 12.5657C6.01527 12.7157 5.81178 12.8 5.59961 12.8H4.79961V13.6C4.79961 13.8122 4.71532 14.0157 4.56529 14.1657C4.41527 14.3157 4.21178 14.4 3.99961 14.4C3.78744 14.4 3.58395 14.3157 3.43392 14.1657C3.2839 14.0157 3.19961 13.8122 3.19961 13.6V12.8H2.39961C2.18744 12.8 1.98395 12.7157 1.83392 12.5657C1.68389 12.4157 1.59961 12.2122 1.59961 12C1.59961 11.7878 1.68389 11.5843 1.83392 11.4343C1.98395 11.2843 2.18744 11.2 2.39961 11.2H3.19961V10.4C3.19961 10.1878 3.2839 9.98435 3.43392 9.83432C3.58395 9.68429 3.78744 9.60001 3.99961 9.60001ZM9.59961 1.60001C9.77616 1.59995 9.94777 1.6583 10.0877 1.76596C10.2276 1.87361 10.328 2.02454 10.3732 2.19521L11.3164 5.76001L13.9996 7.30721C14.1212 7.37742 14.2222 7.47841 14.2924 7.60002C14.3626 7.72163 14.3996 7.85958 14.3996 8.00001C14.3996 8.14043 14.3626 8.27838 14.2924 8.39999C14.2222 8.5216 14.1212 8.62259 13.9996 8.69281L11.3164 10.2408L10.3724 13.8048C10.3271 13.9753 10.2268 14.1261 10.0869 14.2336C9.94709 14.3412 9.77562 14.3995 9.59921 14.3995C9.4228 14.3995 9.25133 14.3412 9.11149 14.2336C8.97166 14.1261 8.87129 13.9753 8.82601 13.8048L7.88281 10.24L5.19961 8.69281C5.078 8.62259 4.97702 8.5216 4.90681 8.39999C4.83661 8.27838 4.79964 8.14043 4.79964 8.00001C4.79964 7.85958 4.83661 7.72163 4.90681 7.60002C4.97702 7.47841 5.078 7.37742 5.19961 7.30721L7.88281 5.75921L8.82681 2.19521C8.87197 2.02467 8.97224 1.87385 9.112 1.7662C9.25177 1.65855 9.4232 1.60013 9.59961 1.60001Z'
      fill='url(#sparklesGradCard)'
    />
    <defs>
      <linearGradient
        id='sparklesGradCard'
        x1='2.33'
        y1='-4'
        x2='2.64'
        y2='14.58'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.573203' stopColor='#FF7875' />
        <stop offset='1' stopColor='#AF231C' />
      </linearGradient>
    </defs>
  </svg>
)

export const PeopleIcon = (props: SVGAttributes<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    {...props}>
    <g clipPath='url(#clip0_742_4507)'>
      <path
        // eslint-disable-next-line max-len
        d='M13.5753 11.3579C13.1284 10.9106 12.6061 10.5455 12.0325 10.2794C12.8414 9.62402 13.3575 8.62402 13.3575 7.50259C13.3575 5.52402 11.7075 3.9008 9.7289 3.93116C7.78068 3.96152 6.21104 5.54902 6.21104 7.50259C6.21104 8.62402 6.7289 9.62402 7.53604 10.2794C6.9623 10.5453 6.44 10.9104 5.99318 11.3579C5.01818 12.3347 4.46461 13.624 4.4289 14.999C4.42842 15.0181 4.43176 15.037 4.43873 15.0548C4.44569 15.0725 4.45614 15.0887 4.46945 15.1024C4.48277 15.116 4.49868 15.1268 4.51625 15.1342C4.53382 15.1416 4.55269 15.1455 4.57175 15.1454H5.57175C5.64854 15.1454 5.71282 15.0847 5.71461 15.0079C5.74854 13.9722 6.16818 13.0026 6.90568 12.2669C7.28307 11.8875 7.73197 11.5867 8.22638 11.3819C8.72079 11.1772 9.25091 11.0725 9.78604 11.074C10.8735 11.074 11.8968 11.4972 12.6664 12.2669C13.4021 13.0026 13.8218 13.9722 13.8575 15.0079C13.8593 15.0847 13.9235 15.1454 14.0003 15.1454H15.0003C15.0194 15.1455 15.0383 15.1416 15.0558 15.1342C15.0734 15.1268 15.0893 15.116 15.1026 15.1024C15.1159 15.0887 15.1264 15.0725 15.1333 15.0548C15.1403 15.037 15.1437 15.0181 15.1432 14.999C15.1075 13.624 14.5539 12.3347 13.5753 11.3579ZM9.78604 9.78831C9.17532 9.78831 8.60032 9.55081 8.16997 9.11866C7.95399 8.90439 7.78339 8.6488 7.66834 8.36716C7.55329 8.08552 7.49615 7.78358 7.50032 7.47938C7.50568 6.89366 7.73961 6.32759 8.14854 5.90795C8.57711 5.46866 9.15032 5.22402 9.76282 5.21688C10.3682 5.21152 10.9557 5.44723 11.3878 5.87045C11.8307 6.30438 12.0735 6.88473 12.0735 7.50259C12.0735 8.11331 11.836 8.68652 11.4039 9.11866C11.1919 9.33169 10.9397 9.50056 10.662 9.6155C10.3843 9.73045 10.0866 9.78918 9.78604 9.78831ZM5.31282 7.97402C5.29675 7.81866 5.28782 7.66152 5.28782 7.50259C5.28782 7.21866 5.31461 6.94188 5.36461 6.67223C5.37711 6.60795 5.34318 6.54188 5.28425 6.51509C5.0414 6.40616 4.81818 6.25616 4.62532 6.06688C4.39807 5.84653 4.21925 5.58124 4.10026 5.28792C3.98127 4.9946 3.92473 4.6797 3.93425 4.36331C3.95032 3.79009 4.18068 3.24545 4.58247 2.83473C5.02354 2.38295 5.61639 2.13652 6.24675 2.14366C6.8164 2.14902 7.36639 2.36866 7.78247 2.75795C7.92354 2.89009 8.04497 3.03652 8.14675 3.19366C8.18247 3.24902 8.25211 3.27223 8.31282 3.2508C8.62711 3.14188 8.95925 3.06509 9.30032 3.02938C9.40032 3.01866 9.45747 2.91152 9.41282 2.82223C8.83247 1.67402 7.64675 0.881162 6.27532 0.859733C4.29497 0.829376 2.64497 2.45259 2.64497 4.42938C2.64497 5.55081 3.16104 6.55081 3.96997 7.20616C3.40211 7.46866 2.8789 7.83116 2.42532 8.28473C1.44675 9.26152 0.893181 10.5508 0.857467 11.9276C0.85699 11.9466 0.860333 11.9656 0.867298 11.9834C0.874264 12.0011 0.884711 12.0173 0.898024 12.0309C0.911338 12.0446 0.927248 12.0554 0.944817 12.0628C0.962386 12.0702 0.981259 12.074 1.00032 12.074H2.00211C2.0789 12.074 2.14318 12.0133 2.14497 11.9365C2.1789 10.9008 2.59854 9.93116 3.33604 9.19545C3.86104 8.67045 4.5039 8.30616 5.20568 8.12938C5.27532 8.11152 5.32175 8.04545 5.31282 7.97402Z'
        fill='black'
        fillOpacity='0.85'
      />
      <path
        // eslint-disable-next-line max-len
        d='M13.5753 11.358C13.1284 10.9107 12.6061 10.5456 12.0325 10.2794C12.8414 9.62408 13.3575 8.62408 13.3575 7.50265C13.3575 5.52408 11.7075 3.90087 9.7289 3.93122C7.78068 3.96158 6.21104 5.54908 6.21104 7.50265C6.21104 8.62408 6.7289 9.62408 7.53604 10.2794C6.9623 10.5454 6.44 10.9105 5.99318 11.358C5.01818 12.3348 4.46461 13.6241 4.4289 14.9991C4.42842 15.0181 4.43176 15.0371 4.43873 15.0548C4.44569 15.0726 4.45614 15.0888 4.46945 15.1024C4.48277 15.1161 4.49868 15.1269 4.51625 15.1343C4.53382 15.1417 4.55269 15.1455 4.57175 15.1455H5.57175C5.64854 15.1455 5.71282 15.0848 5.71461 15.008C5.74854 13.9723 6.16818 13.0027 6.90568 12.2669C7.28307 11.8875 7.73197 11.5868 8.22638 11.382C8.72079 11.1773 9.25091 11.0726 9.78604 11.0741C10.8735 11.0741 11.8968 11.4973 12.6664 12.2669C13.4021 13.0027 13.8218 13.9723 13.8575 15.008C13.8593 15.0848 13.9235 15.1455 14.0003 15.1455H15.0003C15.0194 15.1455 15.0383 15.1417 15.0558 15.1343C15.0734 15.1269 15.0893 15.1161 15.1026 15.1024C15.1159 15.0888 15.1264 15.0726 15.1333 15.0548C15.1403 15.0371 15.1437 15.0181 15.1432 14.9991C15.1075 13.6241 14.5539 12.3348 13.5753 11.358ZM9.78604 9.78837C9.17532 9.78837 8.60032 9.55087 8.16997 9.11872C7.95399 8.90445 7.78339 8.64887 7.66834 8.36722C7.55329 8.08558 7.49615 7.78365 7.50032 7.47944C7.50568 6.89372 7.73961 6.32765 8.14854 5.90801C8.57711 5.46872 9.15032 5.22408 9.76282 5.21694C10.3682 5.21158 10.9557 5.44729 11.3878 5.87051C11.8307 6.30444 12.0735 6.8848 12.0735 7.50265C12.0735 8.11337 11.836 8.68658 11.4039 9.11872C11.1919 9.33175 10.9397 9.50062 10.662 9.61557C10.3843 9.73051 10.0866 9.78924 9.78604 9.78837ZM5.31282 7.97408C5.29675 7.81872 5.28782 7.66158 5.28782 7.50265C5.28782 7.21872 5.31461 6.94194 5.36461 6.6723C5.37711 6.60801 5.34318 6.54194 5.28425 6.51515C5.0414 6.40622 4.81818 6.25622 4.62532 6.06694C4.39807 5.84659 4.21925 5.5813 4.10026 5.28798C3.98127 4.99466 3.92473 4.67976 3.93425 4.36337C3.95032 3.79015 4.18068 3.24551 4.58247 2.83479C5.02354 2.38301 5.61639 2.13658 6.24675 2.14372C6.8164 2.14908 7.36639 2.36872 7.78247 2.75801C7.92354 2.89015 8.04497 3.03658 8.14675 3.19372C8.18247 3.24908 8.25211 3.27229 8.31282 3.25087C8.62711 3.14194 8.95925 3.06515 9.30032 3.02944C9.40032 3.01872 9.45747 2.91158 9.41282 2.82229C8.83247 1.67408 7.64675 0.881223 6.27532 0.859794C4.29497 0.829437 2.64497 2.45265 2.64497 4.42944C2.64497 5.55087 3.16104 6.55087 3.96997 7.20622C3.40211 7.46872 2.8789 7.83122 2.42532 8.28479C1.44675 9.26158 0.893181 10.5509 0.857467 11.9277C0.85699 11.9467 0.860333 11.9657 0.867298 11.9834C0.874264 12.0012 0.884711 12.0173 0.898024 12.031C0.911338 12.0446 0.927248 12.0555 0.944817 12.0629C0.962386 12.0703 0.981259 12.0741 1.00032 12.0741H2.00211C2.0789 12.0741 2.14318 12.0134 2.14497 11.9366C2.1789 10.9009 2.59854 9.93122 3.33604 9.19551C3.86104 8.67051 4.5039 8.30622 5.20568 8.12944C5.27532 8.11158 5.32175 8.04551 5.31282 7.97408Z'
        fill='black'
        fillOpacity='0.85'
      />
    </g>
    <defs>
      <clipPath id='clip0_742_4507'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
